import React from 'react';
import { Button } from '@shadcn/components/ui/button';
import { Dialog, DialogTrigger } from '@shadcn/components/ui/dialog';

import FilterModal from './FilterModal';

const Controls = ({
  expandedProducts,
  toggleAllProducts,
  isFilterModalOpen,
  setIsFilterModalOpen,
  locationsByRegion,
  filters,
  handleFiltersChange,
  handleExportCsv,
  isExporting,
  locationOrder,
}) => {
  return (
    <div className="flex flex-wrap items-center gap-4 mb-4">
      <Button variant="outline" onClick={toggleAllProducts}>
        {expandedProducts.length > 0 ? 'Collapse All' : 'Expand All'}
      </Button>

      <Dialog open={isFilterModalOpen} onOpenChange={setIsFilterModalOpen}>
        <DialogTrigger asChild>
          <Button variant="outline">
            <span className="bx bx-filter-alt mr-2"></span>
            Filters
            {(filters.statusFilter.length > 0 ||
              filters.hasContainer ||
              filters.hasPending) && (
              <span className="ml-2 px-2 py-1 bg-blue-100 text-blue-800 rounded-full text-xs">
                Active
              </span>
            )}
          </Button>
        </DialogTrigger>
        <FilterModal
          locationsByRegion={locationsByRegion}
          filters={filters}
          onFiltersChange={handleFiltersChange}
          isOpen={isFilterModalOpen}
          onClose={() => setIsFilterModalOpen(false)}
          locationOrder={locationOrder}
        />
      </Dialog>

      <Button 
        variant="outline" 
        onClick={handleExportCsv} 
        disabled={isExporting}
      >
        {isExporting ? (
          <>
            <span className="spinner-border spinner-border-sm mr-2" role="status"></span>
            Exporting...
          </>
        ) : (
          'Export CSV'
        )}
      </Button>
    </div>
  );
};

export default Controls;
